import { apiRequest } from '@addsome/redux-store';

const USER_LOG_PATH = '/user-log';

export function setUserLog(accountId: string, productId: string | null, action: string, mediaId?: string): Promise<void> {
  return apiRequest('POST', `${USER_LOG_PATH}/create`, { mediaId: mediaId, accountId: accountId, productId: productId, action: action });
}

